import moment from "moment";

export function setSpanishAsDefaultLanguageForMoment(): void {
    moment.locale('es', {
        months: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre'
        ],
        monthsShort: [
            'Enero.',
            'Feb.',
            'Mar.',
            'Abr.',
            'May.',
            'Jun.',
            'Jul.',
            'Ago.',
            'Sept.',
            'Oct.',
            'Nov.',
            'Dic.'
        ],
        weekdays: [
            'Domingo',
            'Lunes',
            'Martes',
            'Miércoles',
            'Jueves',
            'Viernes',
            'Sábado'
        ],
        weekdaysShort: [
            'Dom.',
            'Lun.',
            'Mar.',
            'Miér.',
            'Jue.',
            'Vier.',
            'Sáb.'
        ],
        weekdaysMin: [
            'Do',
            'Lu',
            'Ma',
            'Mi',
            'Ju',
            'Vi',
            'Sa'
        ]
    });
    moment.locale('es');
}

